import _ from "lodash";

export const getViewStateFromUrl = routerParams => {
  if (routerParams.viewState) {
    const decodedValue = decodeURIComponent(routerParams.viewState);
    return { viewState: JSON.parse(atob(decodedValue)) };
  }

  return {};
};

export const encodeViewStateForUrl = state => (state.viewState ? { viewState: btoa(JSON.stringify(state.viewState)) } : {});

export const setObjectInUrl = (state, transition) => {
  transition.router.stateService.go(".", encodeViewStateForUrl(state), { notify: false, location: "replace" });
};

export const pushToBreadcrumbStack = (breadcrumbStack, routeName) => {
  if (!_.isEmpty(breadcrumbStack)) {
    breadcrumbStack.push(routeName);
  }

  return breadcrumbStack;
};



// WEBPACK FOOTER //
// ./src/helpers/urlHelpers.js